export default "__VITE_ASSET__DAbWhxfl__"